import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`;
